var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckDoubleLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-double-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.76784 8.02661L7.59151 8.85028L12.5297 3.91201L13.3547 4.73697L7.59151 10.5002L3.87918 6.78784L4.70413 5.96289L5.94359 7.20236L6.76784 8.02661ZM6.76883 6.37712L9.65785 3.48804L10.4805 4.3107L7.59151 7.19973L6.76883 6.37712ZM5.11992 9.67593L4.29565 10.5002L0.583344 6.78784L1.4083 5.96289L2.23256 6.7872L2.23187 6.78784L5.11992 9.67593Z",
    fill: "#28C1A2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDoubleLine);
export default __webpack_public_path__ + "static/media/check-double-line.1ff53b301d2b94c663f2169048289c17.svg";
export { ForwardRef as ReactComponent };